// extracted by mini-css-extract-plugin
module.exports = {"calendarContainer":"ClockData_calendarContainer__1xN5p","calendarButtons":"ClockData_calendarButtons__DrnBi"};